import { inject } from 'inversify';

import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { AlertTypesStore } from '@/stores/AlertTypesStore';
import { orderByField } from '@/utils/orderBy';
import { IAlertTypeInfo } from '~/api/IAlertTypeInfo';
import { IAlertTypeUpdateRespMsg } from '~/api/messages/IAlertTypeUpdateRespMsg';
import { IAlertTypesRespMsg } from '~/api/messages/IAlertTypesRespMsg';
import { IDispatchMessage } from '~/api/messages/IDispatchMessage';

@SignalrListener
@service(AlertTypeManager)
export class AlertTypeManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(AlertTypesStore) protected alertTypeStore: AlertTypesStore;

  @SignalrMessage('AlertTypesRespMsg')
  async onAlertTypesRespMsg(response: IAlertTypesRespMsg & IDispatchMessage) {
    this.update(response.alertTypes);
  }

  get getAlertTypes() {
    return orderByField(this.alertTypeStore.all(), this.alertTypeStore.valueKey);
  }

  getAlertType(id: string) {
    return this.alertTypeStore.find(id);
  }

  @SignalrMessage('AlertTypeUpdateRespMsg')
  async onAlertTypeUpdateRespMsg(response: IAlertTypeUpdateRespMsg & IDispatchMessage) {
    this.update([response.alertType]);
  }

  update(alertTypes: IAlertTypeInfo[]) {
    this.alertTypeStore.batchUpdate(alertTypes);
  }

  getAlertTypeName(alertTypeId: string) {
    return this.alertTypeStore.find(alertTypeId)?.alertTypeName;
  }
}
